import type { PartnerStatus } from "@redotech/admin-sdk/rpc/schema/partners/shared";
import type { RedoBadgeColor } from "@redotech/redo-web/arbiter-components/badge/redo-badge";

/**
 * Visual config per partner status. Mirrors V2_STATUS_BADGE_PROPS from
 * onboardings/v2/constants.ts so the admin app feels consistent across
 * features.
 *
 * The exhaustive `Record` ensures every PartnerStatus has a config — adding
 * a new status to the enum will fail the build here until this table is
 * updated.
 */
export const PARTNER_STATUS_BADGE_PROPS: Record<
  PartnerStatus,
  { color: RedoBadgeColor; text: string }
> = {
  active: { color: "success", text: "Active" },
  paused: { color: "warning", text: "Paused" },
  terminated: { color: "error", text: "Terminated" },
};
